import { SeapointLogo } from '../../../design-system/logo/seapoint-logo';
import { Stack } from '../../../design-system/stack/stack';
import { NavItem } from './nav-item';
import { SideNavSectionHeader } from './side-nav-section-header';

export type SideNavItem =
  | 'TRANSACTIONS'
  | 'ACCOUNTS'
  | 'PAYMENTS'
  | 'VENDORS'
  | 'REPORTING'
  | 'INVOICE_PAY'
  | 'PAYROLLS';
type WorkflowSectionSideNavItem = Extract<SideNavItem, 'INVOICE_PAY' | 'PAYROLLS'>;

const workflowSectionSideNavItems: WorkflowSectionSideNavItem[] = ['INVOICE_PAY', 'PAYROLLS'];

type SidenavProps = {
  items: SideNavItem[];
  disabledItems: { item: SideNavItem; label: string }[];
};

export const Sidenav = ({ items, disabledItems }: SidenavProps) => {
  const mainNavItems = items.filter((item) => !workflowSectionSideNavItems.some((i) => i === item));
  const workflowItems = items.filter((item) => workflowSectionSideNavItems.some((i) => i === item));

  return (
    <aside className="w-52 flex-shrink-0 bg-seapoint-gray-background-modal">
      <Stack space={5} className="h-full p-2.5">
        <div className="py-5">
          <SeapointLogo />
        </div>

        <nav className="w-full">
          <Stack space={6} className="w-full">
            {/* Main Navigation Items */}
            <Stack className="w-full">
              {mainNavItems.map((item) => {
                const disabledItem = disabledItems.find((disabled) => disabled.item === item);

                const disabledConfig = disabledItem
                  ? { isDisabled: true as const, label: disabledItem.label }
                  : { isDisabled: false as const };

                return <NavItem key={item} variant={item} disabledConfig={disabledConfig} />;
              })}
            </Stack>

            {/* Workflows Section */}
            {workflowItems.length > 0 && (
              <Stack space={2} className="w-full">
                <SideNavSectionHeader variant="WORKFLOWS" />

                <Stack align="stretch" className="w-full">
                  {workflowItems.map((item) => {
                    const disabledItem = disabledItems.find((disabled) => disabled.item === item);

                    const disabledConfig = disabledItem
                      ? { isDisabled: true as const, label: disabledItem.label }
                      : { isDisabled: false as const };

                    return <NavItem key={item} variant={item} disabledConfig={disabledConfig} />;
                  })}
                </Stack>
              </Stack>
            )}
          </Stack>
        </nav>
      </Stack>
    </aside>
  );
};
